
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/compute",
      function () {
        return require("private-next-pages/compute.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/compute"])
      });
    }
  